import React from "react";
import { Provider } from "react-redux";
import newStore from "../New/store/store";
import NewApp from "../New/App";

export default function CorporatePortalApp() {
  return (
    <Provider store={newStore}>
      <NewApp />
    </Provider>
  );
}
